import React from 'react';
import { Section, TeslaText as Text } from 'components';

import * as styles from './styles.module.scss';

const ThreeColumnsGfv = (props) => {
  const { data } = props;
  const { primary, items } = data;
  const { titlelarge } = primary;

  return (
    <Section sliceName="ThreeColumnsGfv" className={styles.section} containerClassName={styles.container}>
      <Text {...titlelarge} className={styles.title} />
      <div className={styles.cards}>
        {items.map((item) => (
          <div key={item.title?.text} className={styles.card}>
            {item.icon?.url && <img src={item.icon.url} alt={item.icon.alt || ''} className={styles.icon} />}
            <Text {...item.title} as="h3" className={styles.cardTitle} />
            <Text {...item.body1} as="p" className={styles.cardBody} />
          </div>
        ))}
      </div>
    </Section>
  );
};

export default ThreeColumnsGfv;
